<template>
  <div>
    <header class="header">
      <router-link to="/" class="header__logo">Giveandgo</router-link>
      <Breadcrumbs />
      <div class="burger" @click="onMenuToggle">Меню</div>
    </header>
    <MenuComponent />
    <router-view></router-view>
    <!-- <Converter /> -->
  </div>
</template>
<script>
import AjaxProvider from '@/utils/AjaxProvider'
import swal from 'sweetalert'

import MenuComponent from '@/components/Menu.vue'
import Converter from '@/components/Converter.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

import SassStyles from '@/scss/styles.scss'

const name = 'root'

function data() {
  return {
    loaded: false
  }
}

const computed = {
  showMenu() {
    return this.$store.state.template.showMenu
  }
}

function mounted() {
  this.initQuiz()
}

function initQuiz() {
  if (typeof Marquiz == 'undefined') {
    setTimeout(() => {
      this.initQuiz()
    }, 400)
  } else {
    try {
      Marquiz.init({
        id: '5e60b459ad16fa004472f7c5',
        autoOpen: false,
        autoOpenFreq: 'once',
        openOnExit: false
      });

      Marquiz.init({
        id: '60898010a9f4a70044f2cbe3',
        autoOpen: false,
        autoOpenFreq: 'once',
        openOnExit: false
      });

    } catch (e) {
      console.log(e)
    }
  }
}

function created() {
  let inst = this

  inst.$router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    inst.$store.commit('template/setMenuState', false)
    next()
  })
  // provide access to langs for classes outside of Vue instance
  window.lang = function(value) {
    return inst.lang(value)
  }
}

function onMenuToggle() {
  this.$store.commit('template/setMenuState', true)
}

export default {
  name,
  created,
  mounted,
  computed,
  data,
  methods: {
    onMenuToggle,
    initQuiz
  },
  components: {
    MenuComponent,
    Converter,
    Breadcrumbs
  }
}

</script>
